<div class="mv-poles-list">    
    <app-asset-list-header [title]="'MAIN_SIDEBAR.DETAILS_SIDEBAR.ASSET_LIST.MV_POLES'" [addNewText]="'MV_POLES.SINGLE'"></app-asset-list-header>
    <div class="cards-row w-100">
        <div>
            <app-card
            [label]="'MV_POLES.TOTAL'"
            [value]="stats.total"
            [showDropdown]="false"
            [showToggle]="false"
            >        
            </app-card>
        </div>
        <div>
            <app-card
            [label]="'MV_POLES.NUM_11KV_FEEDERS'"
            [value]="stats.numberOf11KvFeeders"
            [showDropdown]="false"
            [showToggle]="false"
            >
            </app-card>
        </div>
        <div>
            <app-card
            [label]="'COMMON.ASSET_STATUS.RETAGGED'"
            [value]="stats.retagged"
            [showDropdown]="false"
            [showToggle]="false"
            >
            </app-card>
        </div>
        <div>
            <app-card
            [label]="'MV_POLES.NUM_MV_LV_RETICULATION'"
            [value]="stats.lvReticulation"
            [showDropdown]="false"
            [showToggle]="false">
            </app-card>
        </div>
        <div>
            <app-card
            [label]="'MV_POLES.IN_GOOD_COND'"
            [value]="stats.goodCondition"
            [showDropdown]="false"
            [showToggle]="false"
            >
            </app-card>
        </div>
    </div>
   <div class="row filter">
    <div class="col-7 filter-bar">
      <app-filter
        (sortChanged)="onSortTypeChange($event)"
        (filterWindow)="onFilterWindowChange($event)"
        (addFilterCard)="onAddFilterCard($event)"
        (clearSearch)="this.filter.search = ''"
      ></app-filter>
      <span *ngIf="appliedFilters.length == 0" class="no-filters">{{'COMMON.NO_FILLTERS_APPLIED' | translate}}</span>
    </div>
    <div class="col-5 text-end download-btn-wrapper">
      <button (click)="download()">{{'COMMON.DOWNLOAD' | translate}} 
        <span style="margin-left: 0.4rem;">
          <svg width="11" height="14" viewBox="0 0 11 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M10.0002 8.39394L5.64415 12.75L1.28809 8.39394M5.64415 12.2273V1.25" stroke="#17171A" stroke-opacity="0.6" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </span>
      </button>
    </div>
  <div *ngIf="appliedFilters.length > 0">
    <app-filter-checklist
        [filters]="checklistItems"
        [useApply]="true"
        (resetFilterEmitter)="resetFilter()"
        (removeFilterEmitter)="removeFilter($event)"
        (applyFilterEmitter)="applyFilter()"
      ></app-filter-checklist>
  </div>
</div>
<div class="table-wrapper">
  <div class="table-container">
    <table>
      <thead>
        <tr>
          <th class="th-checkbox"><input type="checkbox" /></th>
          <th>{{'MV_POLES.SINGLE' | translate}} SLRN</th>
          <th>{{'MV_POLES.SINGLE' | translate}} ID</th>
          <th>{{'MV_POLES.SINGLE' | translate}} NO</th>
          <th>{{"COMMON.TABLE_HEADERS.POLE_TYPE" | translate}}</th>
          <th>{{'TRANSFORMERS.EDIT.11KV_FEEDER_NAME' | translate}}</th>
          <th>{{'MV_POLES.SINGLE' | translate}} {{'COMMON.ADDRESS' | translate}}</th>
          <th>{{"COMMON.UT.SINGLE" | translate}}</th>
          <th>{{"COMMON.BU.SINGLE" | translate}}</th>
          <th>{{"COMMON.VALIDATION_STATUS" | translate}}</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let mvPole of mvPoles" (click)="onRowClick(mvPole.id.toString())">
          <td type="checkbox"><input type="checkbox"/></td>
          <td>{{mvPole.slrn}}</td>
          <td class="centered">{{mvPole.poleId}}</td>
          <td>{{mvPole.poleNumber}}</td>
          <td>{{'COMMON.POLE.TYPE.'+mvPole.poleType.toString().toUpperCase() | translate }}</td>
          <td>{{hasCimDataIntegration ? mvPole.acLineName : mvPole.feeder11Name}}</td>
          <td>{{mvPole.address}}</td>
          <td>{{hasCimDataIntegration ? mvPole.subGeographicalRegionName : mvPole.area}}</td>
          <td>{{hasCimDataIntegration ? mvPole.geographicalRegionName : mvPole.region}}</td>
          <td>
            <span class="status" [ngClass]="{
              'green': mvPole.status == 'Complete',
              'gray': mvPole.status == 'Pending',
              'orange': mvPole.status == 'Assigned' || mvPole.status == 'Retagged',
              'red': mvPole.status == 'Rejected'
            }">{{ 'COMMON.ASSET_STATUS.'+ mvPole.status.toString().toUpperCase() | translate }}</span>
          </td>
          <td>...</td>
        </tr>
      </tbody>
    </table>
    <div class="pagination">
        <app-asset-list-pagination [pageFromList]="currentPage" (pageChanged)="onPageChange($event)" [totalItems]="count"></app-asset-list-pagination>
    </div>
</div>
</div>
<app-mv-pole-filter-window
  *ngIf="isFilterWindowOpened"
  (close)="closeFilterWindow()"
  (addFilter)="onAddFilter($event)"
  (addFilterCards)="onAddFilterCards($event)"
  [appliedFiltersInput]="appliedFilters"
  [filterInput]="filter"
></app-mv-pole-filter-window>
